var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input",class:{ 'input--loading': _vm.isLoading },attrs:{"data-test":"input-box"}},[_c('input',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],staticClass:"input__field",class:{
      'input__field--error': _vm.hasErrors,
      'input__field--positive': _vm.isPositive,
    },attrs:{"data-test":"input"}},'input',_vm.$attrs,false),_vm.listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }